// extracted by mini-css-extract-plugin
module.exports = {"root":"_64e1bdc6c4e6c965c0c3b746f8314a10"};